export default __webpack_public_path__ + "static/media/code.d319aac5.png";